import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  tabindex: "-1",
  class: "pagination__announcer",
  "aria-live": "polite",
  "aria-atomic": "true"
}

import dictionary from "@/i18n/dictionary.json";
type Props = {
  totalPages: number;
  currentPage: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TressPaginationAnnouncer',
  props: {
    totalPages: {},
    currentPage: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t(_unref(dictionary).pagination.ariaListUpdated, 
          {
            pageNumber: _ctx.currentPage,
            totalPages: _ctx.totalPages,
          }
        )), 1))
}
}

})